import { CreateAccessesActionConfigModalProps } from './Types'
import { UnpersistedFileModalV2 } from './UnpersistedFileModalV2'

const CreateAccessesActionConfigModal = ({ assignee, ...rest }: CreateAccessesActionConfigModalProps) => {
  return <UnpersistedFileModalV2 assignee={assignee} {...rest} />
}

export { CreateAccessesActionConfigModal }
